export const Key_Concept = `
<h3>Key Concept</h3>
<hr />
<article id="key-concept">
  <div class="container">
    <div class="row overlap">
      <div class="col-lg-3 md-12"><img src="/assets/images/icons/Light-Bulb.svg" class="light-bulb mx-auto d-block" /></div>
    </div>
    <div class="row overlap">
      <div class="col-lg-1 d-none d-lg-block" style="background-color: transparent"></div>
      <div class="col-lg-11 col-md-12" style="background-color: transparent"><img src="/assets/images/icons/Key-Concept-Cloud.svg" class="cloud mx-auto d-block" /></div>
    </div>
    <div class="row overlap">
      <div class="col-lg-3 d-none d-lg-block" style="background-color: transparent"></div>
      <div class="col-lg-7 col-md-12 body-copy" style="background-color: transparent">
        Remember, self-awareness comes with practice so you might not see improvements straight away! To help you make the most of what you’ve learned in this course, download our short Confidence Guide.
      </div>
      <div class="col-lg-2 d-none d-lg-block" style="background-color: transparent"></div>
    </div>
  </div>
</article>
`;
